import {
  updateState,
  updateQlQuestionnaire,
} from 'containers/QuestionnaireLogic/utils';
import { updateGroupProperties } from '../../utils';

export default function updateConjointOrMaxDiffProperties({
  state,
  refId,
  nodes,
  properties,
}) {
  const { newNodes, globalErrors } = updateGroupProperties({
    refId,
    nodes,
    properties,
    errors: state.errors,
  });

  let newQuestionnaireLogic = state.questionnaireLogic;
  if (properties.repetitions) {
    const newQl = updateQlQuestionnaire({
      nodes: newNodes,
      ql: state.questionnaireLogic.ql,
    });

    newQuestionnaireLogic = updateState({
      ql: newQl,
      questionnaireLogic: state.questionnaireLogic,
    });
  }
  return { newNodes, globalErrors, newQuestionnaireLogic };
}
